import NotFoundPage from 'src/faq/pages/404'
import CategoryPage from 'src/faq/pages/category'
import FaqPage from 'src/faq/pages/faq'
import HomePage from 'src/faq/pages/home'
import SearchPage from 'src/faq/pages/search'
import VueRouter from 'vue-router'

const routes = [
  { path: '/' , name: 'home', component: HomePage },
  { path: '/category/:categoryId', name: 'category',  component: CategoryPage},
  { path: '/faq/:faqId', name: 'faq',  component: FaqPage},
  { path: '/search/', name: 'search',  component: SearchPage},
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFoundPage
  }
]

export default new VueRouter({
  mode: 'history',
  base: '/qa/',
  routes
})
